import { elementScrollPosition } from "./element-scroll-position";
import { parentScrollPosition } from "./parent-scroll-position";
export var offsetParentScrollPosition = function (offsetParentElement, element) { return (offsetParentElement ? elementScrollPosition(offsetParentElement) : parentScrollPosition(element)); };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/offset-parent-scroll-position.js
// module id = 766
// module chunks = 93